import { COLOR_PALETTE } from "constants/colors.constants";

export const getRandomPaletteColor = (): string => COLOR_PALETTE[Math.floor(Math.random() * COLOR_PALETTE.length)];
